import { Directive, input } from '@angular/core';

@Directive({
  selector: 'td[pxc-form-grid-cell]',
  standalone: true,
  host: {
    class: 'text-sm! relative align-middle!',
    '[class.bg-background-secondary!]': 'isHidden()',
    '[class.bg-background-primary-alt!]': 'isReadonly() && !isHidden()',
    '[class.bg-background-primary!]': '!isReadonly() && !isHidden()',
    '[attr.inert]': 'isReadonly() ? "" : null',
  },
})
export class FormGridCellDirective {
  readonly isReadonly = input<boolean>(false);
  readonly isHidden = input<boolean>(false);
}
